import axios from './axios';

export const checkPassword = async (password) => {
  const result = await axios.get(`users/check-password?password=${password}`);
  return result.data;
};

export const saveProfile = async (dataSave) => {
  await axios.put(`users`,dataSave);
}